import { rest } from 'msw';
import { InterviewInfo, LatestInterviewsResponse } from '../types/PatientRequest';

const questionMockIds = {
  binary: 1,
  options: 2,
  multiOptions: 3,
  time: 4,
  number: 5,
  text: 6,
};
const questionMocks = {
  [questionMockIds.binary]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: false,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 0,
              itemType: 'question',
              questionId: 1,
              question: {
                possibleAnswers: ['yes', 'no'],
                displayAnswers: null,
                name: 'A1a',
                title: 'A1',
                subTitle: 'a',
                language: 'en',
                questionPrompt: null,
                questionText:
                  'Were you <u>ever</u> depressed or down, or felt sad, empty or hopeless most of the day, nearly every day, for two weeks?',
                questionHelpText: null,
                clinicianHelpText: 'Clinician help text for MINI interview',
                questionScore: 0,
                displayReportScore: false,
                questionAnswerType: 'binary',
                defaultAnswer: 'no',
                isClinicianOnly: true,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: null,
                questionSkipCheckboxText: null,
                isRequired: true,
                fillPlaceholder: null,
                shouldFillWithTimeframe: null,
              },
            },
          ],
          name: 'A. Major Depressive Disorder',
          letter: 'A',
          title: 'Major Depressive Disorder',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
      reportType: 'mini',
    },
  },
  [questionMockIds.options]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: true,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 0,
              itemType: 'question',
              questionId: questionMockIds.options,
              question: {
                possibleAnswers: ['yes', 'no', 'uncertain'],
                displayAnswers: [''],
                name: 'O1a',
                title: 'O1a',
                subTitle: '',
                language: 'en',
                questionPrompt: '<b>Just before these symptoms began:</b>',
                questionText:
                  'Were you taking any drugs or medicines or in withdrawal from any of these?',
                questionHelpText: '',
                clinicianHelpText:
                  'IF THE PATIENT CODES POSITIVE FOR ANY CURRENT DISORDER OR A MAJOR DEPRESSIVE EPISODE OR A MANIC OR A HYPOMANIC EPISODE ASK:',
                questionScore: null,
                displayReportScore: false,
                questionAnswerType: 'options',
                defaultAnswer: 'no',
                isClinicianOnly: false,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: false,
                questionSkipCheckboxText: '',
                isRequired: false,
                fillPlaceholder: null,
                shouldFillWithTimeframe: null,
              },
            },
          ],
          name: 'O. Rule Out Medical, Organic or Drug Causes for All Disorders',
          letter: 'O',
          title: 'Rule Out Medical, Organic or Drug Causes for All Disorders',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
      reportType: 'mini',
    },
  },
  [questionMockIds.multiOptions]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: true,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 0,
              itemType: 'question',
              questionId: questionMockIds.multiOptions,
              question: {
                possibleAnswers: [
                  'amphetamines',
                  '"speed"',
                  'crystal meth',
                  '"crank"',
                  'Dexedrine',
                  'Ritalin',
                  'diet pills',
                ],
                displayAnswers: [''],
                name: 'J1a_stimulants',
                title: 'J1',
                subTitle: 'a',
                language: 'en',
                questionPrompt: '',
                questionText:
                  '<b>In the past 12 months</b>, did you take any of these drugs more than once, to get high, to feel elated, to get "a buzz" or to change your mood? <br><b>Stimulants</b>',
                questionHelpText:
                  'If none of these were taken in the past 12 months, leave the boxes unchecked and press the submit button.',
                clinicianHelpText: '',
                questionScore: null,
                displayReportScore: false,
                questionAnswerType: 'multiOptions',
                defaultAnswer: '',
                isClinicianOnly: false,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: false,
                questionSkipCheckboxText: '',
                isRequired: false,
                fillPlaceholder: '',
                shouldFillWithTimeframe: false,
              },
            },
          ],
          name: 'J. Substance Use Disorder (Non-alcohol)',
          letter: 'J',
          title: 'Substance Use Disorder (Non-alcohol)',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2 Standard-08-31-20-SKU 10022-13b',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
      reportType: 'mini',
    },
  },
  [questionMockIds.time]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: true,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 38,
              itemType: 'question',
              questionId: questionMockIds.time,
              question: {
                possibleAnswers: [],
                displayAnswers: null,
                name: 'B17_usual_time',
                title: 'B17',
                subTitle: null,
                language: 'en',
                questionPrompt:
                  'Time spent per day with any suicidal impulses, thoughts or actions:',
                questionText: 'Usual time spent per day',
                questionHelpText: null,
                clinicianHelpText: null,
                questionScore: 0,
                displayReportScore: false,
                questionAnswerType: 'time',
                defaultAnswer: '0:00',
                isClinicianOnly: false,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: null,
                questionSkipCheckboxText: null,
                isRequired: true,
                fillPlaceholder: null,
                shouldFillWithTimeframe: null,
              },
            },
          ],
          name: 'B. Suicidality',
          letter: 'B',
          title: 'Suicidality',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2 Standard-08-31-20-SKU 10022-13b',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
    },
    reportType: 'mini',
  },
  [questionMockIds.number]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: true,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 42,
              itemType: 'question',
              questionId: questionMockIds.number,
              question: {
                possibleAnswers: [],
                displayAnswers: null,
                name: 'B18_number_times',
                title: 'B18',
                subTitle: null,
                language: 'en',
                questionPrompt: 'For the previous question',
                questionText: 'How many times?',
                questionHelpText: null,
                clinicianHelpText:
                  '"A suicide attempt is any self injurious behavior, with at least some intent (> 0) to die as a result of the act. Evidence that the individual intended to kill him-or herself, at least to some degree, can be explicit or inferred from the behavior or circumstance. For example, it is defined as a suicide attempt if it is clearly not an accident or if the individual thinks the act could be lethal, even though denying intent." (FDA Guidance for Industry Suicidal Ideation and Behavior Document 2012 and C-CASA definition). Posner K et al. Am J Psychiatry 2007; 164 (7): 1035-1043 & http://www.fda.gov/Drugs/GuidanceComplianceRegulatoryInformation/Guidances/default.htm/',
                questionScore: 0,
                displayReportScore: false,
                questionAnswerType: 'number',
                defaultAnswer: '0',
                isClinicianOnly: false,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: null,
                questionSkipCheckboxText: null,
                isRequired: true,
                fillPlaceholder: null,
                shouldFillWithTimeframe: null,
              },
            },
          ],
          name: 'B. Suicidality',
          letter: 'B',
          title: 'Suicidality',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2 Standard-08-31-20-SKU 10022-13b',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
      reportType: 'mini',
    },
  },
  [questionMockIds.text]: {
    interviewTestId: 1,
    success: true,
    completed: false,
    canNavigateBack: true,
    interview: {
      modules: [
        {
          sequenceOrders: [
            {
              sequenceOrder: 1,
              itemType: 'question',
              questionId: questionMockIds.text,
              question: {
                possibleAnswers: [],
                displayAnswers: null,
                name: 'C_unscored_followup',
                title: null,
                subTitle: null,
                language: 'en',
                questionPrompt: 'For the previous question',
                questionText: 'Please specify who:',
                questionHelpText: null,
                clinicianHelpText: null,
                questionScore: 0,
                displayReportScore: false,
                questionAnswerType: 'text',
                defaultAnswer: null,
                isClinicianOnly: false,
                isPatientOnly: false,
                shouldFillPromptWAnswerValue: false,
                shouldFillQuestionWAnswerValue: false,
                questionCanBeSkippedWithOption: null,
                questionSkipCheckboxText: null,
                isRequired: true,
                fillPlaceholder: null,
                shouldFillWithTimeframe: null,
              },
            },
          ],
          name: 'C. Manic and Hypomanic Episodes',
          letter: 'C',
          title: 'Manic and Hypomanic Episodes',
          language: 'en',
        },
      ],
      name: 'M.I.N.I. 7.0.2 Standard-08-31-20-SKU 10022-13b',
      title: 'M.I.N.I.',
      subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
      language: 'en',
      versionNumber: '7.0.2',
      backNavigationClinician: true,
      backNavigationPatient: null,
      hasPrimaryDiagnosis: true,
      hasTimeframe: null,
      reportType: 'mini',
    },
  },
};

const mocks = [
  rest.get('/v1/interview/stats', (req, res, ctx) => {
    return res(
      ctx.json({
        totalInterviews: 52,
        incompleteInterviews: 5,
      })
    );
  }),

  rest.get<LatestInterviewsResponse>(
    '/v1/interview/latest-interviews',
    (req, res, ctx) => {
      const page = req.url.searchParams.get('page');
      const pageSize = req.url.searchParams.get('pageSize');


      const interviewTypes = [
        {
          id: '1',
          name: 'Mini 7.0.2 for Psychotic Disoders Studies',
          status: 'Not Started',
          createdAt: '2020-05-03 02:56:42.000 +0700',
        },
        {
          id: '2',
          name: 'Mini 7.0.2.',
          status: 'In Progress',
          createdAt: '2020-05-03 03:06:31.000 +0700',
        },
        {
          id: '3',
          name: 'Manic Monitor',
          status: '10/01/2021',
          createdAt: '2020-05-03 03:09:18.000 +0700',
        },
        {
          id: '4',
          name: 'Manic Monitor',
          status: 'Not Started',
          createdAt: '2020-05-04 19:52:41.000 +0700',
        },
        {
          id: '5',
          name: 'Manic Monitor',
          status: '10/01/2021',
          createdAt: '2020-06-04 23:15:59.000 +0700',
        },
        {
          id: '6',
          name: 'Manic Monitor',
          status: 'In Progress',
          createdAt: '2020-06-04 23:16:22.000 +0700',
        },
        {
          id: '7',
          name: 'Mini 7.0.2.',
          status: '10/01/2021',
          createdAt: '2020-06-06 18:57:14.000 +0700',
        },
        {
          id: '8',
          name: 'Manic Monitor',
          status: 'Not Started',
          createdAt: '2020-05-13 23:14:51.000 +0700',
        },
        {
          id: '9',
          name: 'Mini 7.0.2.',
          status: 'In Progress',
          createdAt: '2020-05-13 23:13:09.000 +0700',
        },
        {
          id: '10',
          name: 'Mini 7.0.2.',
          status: 'In Progress',
          createdAt: '2020-07-15 02:27:00.000 +0700',
        },
        {
          id: '11',
          name: 'Mini 7.0.2.',
          status: 'In Progress',
          createdAt: '2020-07-15 02:29:26.000 +0700',
        },
        {
          id: '12',
          name: 'Manic Monitor',
          status: 'Not Started',
          createdAt: '2020-07-16 23:35:13.000 +0700',
        },
        {
          id: '13',
          name: 'Mini 7.0.2.',
          status: 'In Progress',
          createdAt: '2020-07-27 00:54:22.000 +0700',
        },
      ];

      const currentPage = parseInt(page!);
      const limitItemPerPage = parseInt(pageSize!);

      const totalInterviewTypes = interviewTypes.length;
      const startIndex = (currentPage - 1) * limitItemPerPage;
      const endIndex = currentPage * limitItemPerPage;
      const paginationData = interviewTypes.slice(startIndex, endIndex);

      return res(
        ctx.status(200),
        ctx.json({
          interviewTypes: paginationData,
          totalInterviewTypes,
        })
      );
    }
  ),

  rest.post<InterviewInfo>('/v1/interview/start-interview', (req, res, ctx) => {
    console.log(req.body);

    const { interview } = req.body;
    if (interview === '111') {
      return res(
        ctx.status(400),
        ctx.json({
          error: ['Some setup field was not incorrect.'],
        })
      );
    }

    return res(ctx.status(200));
  }),

  // TODO: update URL once done backend change (e.g. use kebab-case)
  rest.post<any>('/v1/interview/request-interview', (req, res, ctx) => {
    const { interviewTestId } = req.body;

    // MINI
    if (interviewTestId === 1) {
      return res(
        ctx.json({
          ...questionMocks[questionMockIds.binary],
          interviewId: 1,
          interviewMode: 'C',
          nViewPatientId: '604084564731',
          extPatientId: 'ext-tri-002',
          language: 'en',
        })
      );
    }

    // Screener
    if (interviewTestId === 2) {
      return res(
        ctx.json({
          interviewId: 2,
          interviewMode: 'C',
          interviewTestId: 75075,
          nViewPatientId: '604084564731',
          extPatientId: 'ext-tri-002',
          language: 'en',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 0,
                    itemType: 'question',
                    questionId: 415,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenA1',
                      title: 'A',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you been depressed or down, or felt sad, empty or hopeless <b>most of the day, nearly every day</b>, for the past two weeks?',
                      questionHelpText: null,
                      clinicianHelpText: 'This is the clinician help text',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                    },
                  },
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 416,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenA2',
                      title: 'A',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'In the past two weeks, were you much less interested in most things or much less able to enjoy the things you used to enjoy <b>most of the time</b>?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                    },
                  },
                  {
                    sequenceOrder: 19,
                    itemType: 'question',
                    questionId: 434,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'ScreenL_height',
                      title: 'L',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'How tall are you?',
                      questionHelpText: 'This is question help text',
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'height',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                    },
                  },
                  {
                    sequenceOrder: 20,
                    itemType: 'question',
                    questionId: 435,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'ScreenL_weight',
                      title: 'L',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'What was your lowest weight in the past 3 months?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'weight',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                    },
                  },
                ],
                name: 'MINI Screen 7.0.2 Main Module',
                letter: '1',
                title: '',
                language: 'en',
              },
            ],
            name: 'M.I.N.I. Screen 7.0.2',
            title: 'Screener for MINI 7.0.2',
            subTitle: 'Adult Version',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: null,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: null,
          },
        })
      );
    }

    // PHQ-9
    if (interviewTestId === 3) {
      return res(
        ctx.json({
          interviewId: 232,
          interviewMode: 'C',
          interviewTestId: 75257,
          nViewPatientId: '135129837155',
          extPatientId: 'QAZ',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 0,
                    itemType: 'question',
                    questionId: 220435,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days More than half the days More than half the days More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: [''],
                      name: '1',
                      title: '1',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText: 'Little interest or pleasure in doing things?',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 220436,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '2',
                      title: '2',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText: 'Feeling down, depressed, or hopeless?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 220437,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '3',
                      title: '3',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText: 'Trouble falling or staying asleep, or sleeping too much?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 220438,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '4',
                      title: '4',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText: 'Feeling tired or having little energy?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 4,
                    itemType: 'question',
                    questionId: 220439,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '5',
                      title: '5',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText: 'Poor appetite or overeating?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 5,
                    itemType: 'question',
                    questionId: 220440,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '6',
                      title: '6',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText:
                        'Feeling bad about yourself — or that you are a failure or have let yourself or your family down?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 6,
                    itemType: 'question',
                    questionId: 220441,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '7',
                      title: '7',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText:
                        'Trouble concentrating on things, such as reading the newspaper or watching television?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 7,
                    itemType: 'question',
                    questionId: 220442,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '8',
                      title: '8',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText:
                        'Moving or speaking so slowly that other people could have noticed? Or so fidgety or restless that you have been moving a lot more than usual?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 8,
                    itemType: 'question',
                    questionId: 220443,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Several days',
                        'More than half the days',
                        'Nearly every day',
                      ],
                      displayAnswers: null,
                      name: '9',
                      title: '9',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt:
                        'How often have you been bothered by the following over the past 2 weeks?',
                      questionText:
                        'Thoughts that you would be better off dead, or thoughts of hurting yourself in some way?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                  {
                    sequenceOrder: 9,
                    itemType: 'question',
                    questionId: 220445,
                    question: {
                      possibleAnswers: [
                        'Not at all',
                        'Somewhat difficult',
                        'Very difficult',
                        'Extremely difficult',
                      ],
                      displayAnswers: [''],
                      name: '10',
                      title: '10',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: '',
                      questionText:
                        'How difficult have these problems made it to do work, take care of things at home, or get along with other people?',
                      questionHelpText: '',
                      clinicianHelpText:
                        'Optional, not included in final score but may help assess global impairment',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                ],
                name: null,
                letter: 'A',
                title: 'Main',
                language: 'uni',
              },
            ],
            name: 'PHQ-9 v1',
            title: 'PHQ-9 v1',
            subTitle: 'PHQ-9 v1',
            language: 'uni',
            versionNumber: '0.1',
            backNavigationClinician: true,
            backNavigationPatient: false,
            hasPrimaryDiagnosis: false,
            hasTimeframe: false,
            reportType: 'miniScreener',
          },
        })
      );
    }

    // MultiSelectList
    if (interviewTestId === 4) {
      return res(
        ctx.json({
          interviewId: 243,
          interviewMode: 'C',
          interviewTestId: 75467,
          nViewPatientId: '142244682996',
          extPatientId: null,
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 7,
                    itemType: 'question',
                    questionId: 223419,
                    question: {
                      possibleAnswers: [
                        'With anxious distress',
                        'With mixed features',
                        'With melancholic features',
                        'With atypical features',
                        'With mood congruent psychotic features (have typical depressive themes) MDD',
                        'With mood congruent psychotic features (have typical depressive themes) BPD',
                        'With mood-incongruent psychotic features MDD',
                        'With mood-incongruent psychotic features BPD',
                        'With catatonia',
                        'With peripartum onset (during pregnancy or within 4 weeks of delivery)',
                        'With seasonal pattern',
                        'In partial remission (some symptoms in past 2 months)',
                        'In full remission (no signs or symptoms for past 2 months)',
                        'Mild (few symptoms and minor impairment)',
                        'Moderate (symptoms and impairment between mild and severe)',
                        'Severe (number & intensity of symptoms & degree of impairment is marked)',
                      ],
                      displayAnswers: [''],
                      name: 'SPECIFIERS FOR DEPRESSIVE OR BIPOLAR OR RELATED DISORDERS',
                      title: '',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'SPECIFIERS FOR DEPRESSIVE OR BIPOLAR OR RELATED DISORDERS',
                      questionText: 'Mark all that apply',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'multiSelectList',
                      defaultAnswer: '',
                      isClinicianOnly: true,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                    },
                  },
                ],
                name: 'Ae. Major Depressive Episode with Atypical Features',
                letter: 'Ae',
                title: 'Major Depressive Episode with Atypical Features',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 223419,
                answer: {
                  value: 'With catatonia|With mood-incongruent psychotic features BPD',
                },
              },
            ],
            name: 'M.I.N.I. 7.0.2 - 10-28-2021',
            title: 'M.I.N.I.',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: true,
            hasTimeframe: null,
            reportType: 'mini',
          },
        })
      );
    }

    // TimeDayMonth
    if (interviewTestId === 5) {
      return res(
        ctx.json({
          interviewId: 286,
          interviewMode: 'C',
          interviewTestId: 75585,
          nViewPatientId: '142244682996',
          extPatientId: null,
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 31,
                    itemType: 'question',
                    questionId: 225515,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: [''],
                      name: 'Q13d',
                      title: 'Q13',
                      subTitle: 'd',
                      language: 'en',
                      questionPrompt: 'DISABILITY',
                      questionText:
                        'what was the longest time you were treated with medication or were hospitalized for these problems?',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'time (Day/Month)',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                name: 'Q. Psychotic Disorders and Mood Disorders With Psychotic Features',
                letter: 'Q.',
                title: 'Psychotic Disorders and Mood Disorders With Psychotic Features',
                language: 'en',
              },
            ],
            name: 'M.I.N.I. Kid 7.0.2 for Children and Adolescents',
            title: 'M.I.N.I. KID',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW FOR CHILDREN AND ADOLESCENTS',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: false,
            hasPrimaryDiagnosis: true,
            hasTimeframe: false,
            reportType: 'mini',
            previousAnswers: [
              {
                answer: {
                  value: '010203',
                },
                questionId: 225515,
              },
            ],
            previousClinicianNotes: '',
          },
        })
      );
    }

    // Number
    if (interviewTestId === 6) {
      return res(
        ctx.json({
          interviewId: 4,
          interviewMode: 'C',
          interviewTestId: 75780,
          nViewPatientId: '119458076582',
          extPatientId: 'EXT150222133152',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 26,
                    itemType: 'question',
                    questionId: 878,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: null,
                      name: 'A6',
                      title: 'A6',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'How many episodes of depression did you have in your lifetime? Between each episode there must be at least 2 months without any significant depression.',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'number',
                      defaultAnswer: '0',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                name: 'A. Major Depressive Disorder',
                letter: 'A',
                title: 'Major Depressive Disorder',
                language: 'en',
              },
            ],
            name: 'M.I.N.I. Kid 7.0.2 for Children and Adolescents',
            title: 'M.I.N.I. KID',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW FOR CHILDREN AND ADOLESCENTS',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: true,
            hasTimeframe: false,
            reportType: 'mini',
          },
        })
      );
    }

    // Time
    if (interviewTestId === 7) {
      return res(
        ctx.json({
          interviewId: 4,
          interviewMode: 'C',
          interviewTestId: 75780,
          nViewPatientId: '119458076582',
          extPatientId: 'EXT150222133152',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 39,
                    itemType: 'question',
                    questionId: 917,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: null,
                      name: 'B17_usual_time_13to17',
                      title: 'B17',
                      subTitle: null,
                      language: 'en',
                      questionPrompt:
                        'Time spent per day with any suicidal impulses, thoughts or actions:',
                      questionText: 'Usual time spent per day',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'time',
                      defaultAnswer: '0:00',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                name: 'B. Suicidality',
                letter: 'B',
                title: 'Suicidality',
                language: 'en',
              },
            ],
            name: 'M.I.N.I. Kid 7.0.2 for Children and Adolescents',
            title: 'M.I.N.I. KID',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW FOR CHILDREN AND ADOLESCENTS',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: true,
            hasTimeframe: false,
            reportType: 'mini',
          },
        })
      );
    }

    // MultiOptions
    if (interviewTestId === 8) {
      return res(
        ctx.json({
          interviewId: 197,
          interviewMode: 'C',
          interviewTestId: 75763,
          nViewPatientId: '135129837155',
          extPatientId: 'QAZ',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 0,
                    itemType: 'question',
                    questionId: 213435,
                    question: {
                      possibleAnswers: [
                        'Steroids',
                        'Nonprescription Sleep Or Diet Pills',
                        'Other',
                        '"crank"',
                        'Dexedrine',
                        'Ritalin',
                        'diet pills',
                      ],
                      displayAnswers: [''],
                      name: 'J1a_stimulants',
                      title: 'J1',
                      subTitle: 'a',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        '<b>In the past 12 months</b>, did you take any of these drugs more than once, to get high, to feel elated, to get "a buzz" or to change your mood? <br><b>Stimulants</b>',
                      questionHelpText:
                        'If none of these were taken in the past 12 months, leave the boxes unchecked and press the submit button.',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'multiOptions',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                name: 'J. Substance Use Disorder (Non-alcohol)',
                letter: 'J',
                title: 'Substance Use Disorder (Non-alcohol)',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 213435,
                answer: {
                  value: 'Other|Nonprescription Sleep Or Diet Pills',
                },
              },
            ],
            name: 'M.I.N.I. 7.0.2 Standard-08-31-20-SKU 10022-13b',
            title: 'M.I.N.I.',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: true,
            hasTimeframe: null,
            reportType: 'mini',
            previousClinicianNotes: 'This is clinician note',
          },
        })
      );
    }

    // Question with link in 'clinicianHelpText'
    if (interviewTestId === 9) {
      return res(
        ctx.json({
          interviewId: 82,
          interviewMode: 'C',
          interviewTestId: 76015,
          nViewPatientId: '148674133408',
          extPatientId: 'qaz',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 43,
                    itemType: 'question',
                    questionId: 70,
                    question: {
                      possibleAnswers: [
                        'current: within the past 12 months',
                        'in early remission: between 12 and 24 months ago',
                        'in remission: more than 24 months ago',
                      ],
                      displayAnswers: null,
                      name: 'B18_last_attempt',
                      title: 'B18',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: 'For the previous question',
                      questionText: 'When was the last suicide attempt?',
                      questionHelpText: null,
                      clinicianHelpText:
                        '"A suicide attempt is any self injurious behavior, with at least some intent (> 0) to die as a result of the act. Evidence that the individual intended to kill him-or herself, at least to some degree, can be explicit or inferred from the behavior or circumstance. For example, it is defined as a suicide attempt if it is clearly not an accident or if the individual thinks the act could be lethal, even though denying intent." (FDA Guidance for Industry Suicidal Ideation and Behavior Document 2012 and C-CASA definition). Posner K et al. Am J Psychiatry 2007; 164 (7): 1035-1043 & http://www.fda.gov/Drugs/GuidanceComplianceRegulatoryInformation/Guidances/default.htm/',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'options',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                name: 'B. Suicidality',
                letter: 'B',
                title: 'Suicidality',
                language: 'en',
              },
            ],
            name: 'M.I.N.I. 7.0.2',
            title: 'M.I.N.I.',
            subTitle: 'MINI INTERNATIONAL NEUROPSYCHIATRIC INTERVIEW',
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: true,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: true,
            hasTimeframe: null,
            reportType: 'mini',
          },
        })
      );
    }

    // CY-BOCS - Check List and Check List Other
    if (interviewTestId === 10) {
      return res(
        ctx.json({
          interviewId: 103,
          interviewMode: 'C',
          interviewTestId: 3735,
          nViewPatientId: '767697683080',
          extPatientId: 'Ext0001',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 218717,
                    question: {
                      possibleAnswers: ['current', 'past', 'principal'],
                      displayAnswers: null,
                      name: 'tets esf:',
                      title: 'rerew:',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'rerew:',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsCheckList',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 218718,
                    question: {
                      possibleAnswers: ['current', 'past', 'principal'],
                      displayAnswers: null,
                      name: 'Measures (not checking) to prevent:',
                      title: 'Measures (not checking) to prevent:',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'Measures (not checking) to prevent:',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsCheckList',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 218719,
                    question: {
                      possibleAnswers: ['harm_to_self', 'harm_to_others', 'terrible_consequences'],
                      displayAnswers: ['Harm to self', 'Harm to others', 'Terrible consequences'],
                      name: 'Harm to self__Harm to others__Terrible consequences',
                      title: 'Harm to self__Harm to others__Terrible consequences',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'Harm to self__Harm to others__Terrible consequences',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsCheckList',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: 218718,
                    },
                  },
                  {
                    sequenceOrder: 11,
                    itemType: 'question',
                    questionId: 218726,
                    question: {
                      possibleAnswers: ['current', 'past', 'principal'],
                      displayAnswers: null,
                      name: 'Other (Describe)',
                      title: 'Other (Describe)',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'Other (Describe)',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsCheckList',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 12,
                    itemType: 'question',
                    questionId: 218727,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'Other (Describe)',
                      title: 'Other (Describe)',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'Other (Describe)',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsCheckOther',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: 218726,
                    },
                  },
                  {
                    sequenceOrder: 13,
                    itemType: 'question',
                    questionId: 218730,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'Items marked "*" may or may not be OCD phenomena.',
                      title: '',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: 'Items marked "*" may or may not be OCD phenomena.',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'infoNoAnswer',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 1616,
                name: 'CHECKLIST: MISCELLANEOUS COMPULSIONS',
                letter: 'P',
                title: 'MISCELLANEOUS COMPULSIONS',
                language: 'uni',
              },
            ],
            name: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            title: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            subTitle: 'CY-BOCS',
            language: 'uni',
            versionNumber: '1.0.0',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: false,
            reportType: 'cybocs',
            modulesForScoring: [
              1609, 1613, 1605, 1608, 1607, 1614, 1615, 1616, 1610, 1623, 1617, 1618, 1619, 1620,
              1621, 1622, 1611, 1603, 1606, 1612, 1604, 1602,
            ],
          },
        })
      );
    }

    // CY-BOCS - targetSymptomListText
    if (interviewTestId === 11) {
      return res(
        ctx.json({
          interviewId: 103,
          interviewMode: 'C',
          interviewTestId: 3735,
          nViewPatientId: '767697683080',
          extPatientId: 'Ext0001',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 218665,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'PRIMARY OBSESSIONS',
                      title: '(Describe, listing by order of severity)',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: '(Describe, listing by order of severity)',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'targetSymptomListText',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 218666,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: '1.',
                      title: '1.',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: ' ',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'text',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 4,
                    itemType: 'question',
                    questionId: 218667,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: '2.',
                      title: '2.',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: ' ',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'text',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 5,
                    itemType: 'question',
                    questionId: 218668,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: '3.',
                      title: '3.',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: ' ',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'text',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 7,
                    itemType: 'question',
                    questionId: 218669,
                    question: {
                      possibleAnswers: null,
                      displayAnswers: null,
                      name: 'AVOIDANCE',
                      title: 'AVOIDANCE',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText: ' ',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'text',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: false,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 1606,
                name: 'TARGET SYMPTOM LIST FOR OBSESSIONS',
                letter: 'Q',
                title: 'TARGET SYMPTOM LIST',
                language: 'uni',
              },
            ],
            name: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            title: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            subTitle: 'CY-BOCS',
            language: 'uni',
            versionNumber: '1.0.0',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: false,
            reportType: 'cybocs',
            modulesForScoring: [
              1609, 1613, 1605, 1608, 1607, 1614, 1615, 1616, 1610, 1623, 1617, 1618, 1619, 1620,
              1621, 1622, 1611, 1603, 1606, 1612, 1604, 1602,
            ],
          },
        })
      );
    }

    // CY-BOCS - ybocsScale
    if (interviewTestId === 12) {
      return res(
        ctx.json({
          interviewId: 103,
          interviewMode: 'C',
          interviewTestId: 3735,
          nViewPatientId: '767697683080',
          extPatientId: 'Ext0001',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: true,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 218731,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: ['NONE', 'MILD', 'MODERATE', 'SEVERE', 'EXTREME'],
                      displayAnswers: [
                        '',
                        'less than 1 hr/day or occasional intrusion',
                        '1 to 3 hrs/day or frequent intrusion',
                        'greater than 3 and up to 8 hrs/day or very frequent intrusion',
                        'greater than 8 hrs/day or near constant intrusion',
                      ],
                      name: '1. TIME OCCUPIED BY OBSESSIVE THOUGHTS',
                      title: '1. TIME SPENT ON OBSESSIONS',
                      subTitle: '1.',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        '<p style="margin:0;">How much time do you spend thinking about these things?</p>\r\n<p style="margin:0; text-indent: 40px;">[When obsessions occur as brief, intermittent intrusions, it may be impossible to\r\nassess time occupied by them in terms of total hours. In such cases, estimate time by determining how frequently they occur. Consider both the number of times the intrusions occur and how many hours of the day are affected].</p>\r\n<p style="margin:0;">How frequently do these thoughts occur?</p>\r\n<p style="margin:0; text-indent: 40px">[Be sure to exclude ruminations and preoccupations which, unlike obsessions, are ego-syntonic and rational (but exaggerated).]</p>',
                      questionHelpText: null,
                      clinicianHelpText:
                        '<b>"I am now going to ask you questions about the thoughts you cannot stop thinking about."</b>',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 218732,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: [
                        'NO SYMPTOMS',
                        'LONG',
                        'MODERATELY LONG',
                        'SHORT',
                        'EXTREMELY SHORT',
                      ],
                      displayAnswers: [
                        '',
                        'long symptom free intervals or more than 8 consecutive hrs/day symptom-free',
                        'moderately long symptom-free intervals or more than 3 and up to 8 consecutive hrs/day symptom-free',
                        'brief symptom-free intervals or from 1 to 3 consecutive hrs/day symptom-free',
                        'less than 1 consecutive hr/day symptom free',
                      ],
                      name: '1B. OBSESSION-FREE INTERVAL (not included in total score)',
                      title: '1B. OBSESSION-FREE INTERVAL (do not add to subtotal or total score)',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        'On the average, what is the longest amount of time each day that you are not bothered by the obsessive thoughts?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 218733,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: ['NONE', 'MILD', 'MODERATE', 'SEVERE', 'EXTREME'],
                      displayAnswers: [
                        '',
                        'slight interference with social or school activities| but overall performance not impaired',
                        'definite interference with social or school performance| but still manageable',
                        'causes substantial impairment in social or school performance',
                        'incapacitating',
                      ],
                      name: '2. INTERFERENCE DUE TO OBSESSIVE THOUGHTS',
                      title: '2. INTERFERENCE FROM OBSESSIONS',
                      subTitle: '2.',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        '<p style="margin:0;">How much do these thoughts get in the way of school or doing things with friends? Is there anything that you don\'t do because of them?</p>\r\n<p style="margin:0; text-indent: 40px;">(If currently not in school determine how much performance would be affected if patient were in school.)</p>',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 4,
                    itemType: 'question',
                    questionId: 218734,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: ['NONE', 'MILD', 'MODERATE', 'SEVERE', 'EXTREME'],
                      displayAnswers: [
                        '',
                        'infrequent| and not too disturbing',
                        'frequent| and disturbing but still manageable',
                        'very frequent| and very disturbing',
                        'near constant| and disabling distress/frustration',
                      ],
                      name: '3. DISTRESS ASSOCIATED WITH OBSESSIVE THOUGHTS',
                      title: '3. DISTRESS OF OBSESSIONS',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        '<p style="margin:0;">How much do these thoughts bother or upset you?</p>\r\n<p style="margin:0; text-indent: 40px;">(Only rate anxiety/frustration that seems triggered by obsessions, not generalized anxiety or anxiety associated with other symptoms.)</p>',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 5,
                    itemType: 'question',
                    questionId: 218735,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: ['ALWAYS RESISTS', '', '', '', 'COMPLETELY YIELDS'],
                      displayAnswers: [
                        "makes an effort to always resist or symptoms so minimal doesn't need to actively resist.",
                        'tries to resist most of the time',
                        'makes some effort to resist',
                        'yields to all obsessions without attempting to control them| but does so with some reluctance',
                        'completely and willingly yields to all obsessions',
                      ],
                      name: '4. RESISTANCE AGAINST OBSESSIONS',
                      title: '4. RESISTANCE AGAINST OBSESSIONS',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        '<p style="margin:0;">How hard do you try to stop the thoughts or ignore them?</p>\r\n<p style="margin:0; text-indent: 40px;">(Only rate effort made to resist, not success or failure in actually controlling the\r\nobsessions. How much patient resists the obsessions may or may not correlate with\r\ntheir ability to control them. Note that this item does not directly measure the\r\nseverity of the intrusive thoughts; rather it rates a manifestation of health, i.e. , the\r\neffort the patient makes to counteract the obsessions. Thus, the more the patient tries\r\nto resist, the less impaired is this aspect of his/her functioning. If the obsessions are minimal, the patient may not feel the need to resist them. In such cases, a rating of "0" should be given.)</p>',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 6,
                    itemType: 'question',
                    questionId: 218736,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      possibleAnswersText: [
                        'COMPLETE CONTROL',
                        'MUCH CONTROL',
                        'MODERATE CONTROL',
                        'LITTLE CONTROL',
                        'NO CONTROL',
                      ],
                      displayAnswers: [
                        '',
                        'usually able to stop or divert obsessions with some effort and concentration',
                        'sometimes able to stop or divert obsessions',
                        'rarely successful in stopping obsessions| can only divert attention with difficulty',
                        'experienced as completely involuntary| rarely able to even momentarily divert thinking',
                      ],
                      name: '5. DEGREE OF CONTROL OVER OBSESSIVE THOUGHTS',
                      title: '5. CONTROL OVER OBSESSIONS',
                      subTitle: '',
                      language: 'uni',
                      questionPrompt: null,
                      questionText:
                        '<p style="margin:0;">When you try to fight the thoughts, can you beat them?</p> <p style="margin:0;">How much control do you have over the thoughts?</p>\r\n<p style="margin:0; text-indent: 40px;">(In contrast to the preceding item on resistance, the ability of the patient to control his/her obsessions is more closely related to the severity of the intrusive thoughts.)</p>',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'ybocsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 1604,
                name: 'QUESTIONS ON OBSESSION (ITEMS 1-5)',
                letter: 'S',
                title: 'QUESTIONS ON OBSESSION (ITEMS 1-5)',
                language: 'uni',
              },
            ],
            name: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            title: "Children's Yale-Brown Obsessive Compulsive Scale (CY-BOCS)",
            subTitle: 'CY-BOCS',
            language: 'uni',
            versionNumber: '1.0.0',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: false,
            reportType: 'cybocs',
            modulesForScoring: [
              1609, 1613, 1605, 1608, 1607, 1614, 1615, 1616, 1610, 1623, 1617, 1618, 1619, 1620,
              1621, 1622, 1611, 1603, 1606, 1612, 1604, 1602,
            ],
          },
        })
      );
    }

    // Sts-scale
    if (interviewTestId === 13) {
      return res(
        ctx.json({
          interviewId: 39,
          interviewMode: 'C',
          interviewTestId: 76687,
          nViewPatientId: '119458076582',
          extPatientId: 'EXT150222133152',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 20909,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4'],
                      displayAnswers: null,
                      name: '1a',
                      title: '1',
                      subTitle: 'a',
                      language: 'en',
                      questionPrompt: 'In the past (timeframe):',
                      questionText:
                        'how seriously did you plan or intend to hurt yourself in any accident, either by not avoiding a risk or by causing the accident on purpose?',
                      questionHelpText: '',
                      clinicianHelpText:
                        'If the answer to question 1a is 0 (= Not at all), skip to Question 2.<br>If the score is 1 or higher, go to Question 1b.',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'stsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 20909,
                answer: {
                  value: 2,
                },
              },
            ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    // Grid Question
    if (interviewTestId === 14) {
      return res(
        ctx.json({
          interviewId: 30,
          interviewMode: 'C',
          interviewTestId: 3690,
          nViewPatientId: '506221267444',
          extPatientId: '',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 50,
                    itemType: 'question',
                    questionId: 20952,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: [''],
                      name: 'Current Factors',
                      title: 'Current Factors',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        '{\\r\\n    "options": ["<b>Does Not Apply</b>","Lessens Suicidality <em>A lot</em>","Lessens Suicidality <em>Moderately</em>","Lessens Suicidality <em>A little</em>","<b>No impact on Suicidality</b>","Increases Suicidality <em>A little</em>","Increases Suicidality <em>Moderately</em>","Increases Suicidality <em>A lot</em>"],\\r\\n    "sections": [\\r\\n        {\\r\\n            "title": "Suicidality",\\r\\n            "questions": [\\r\\n                {\\r\\n                    "title": "1",\\r\\n                    "text": "Any suicidal impulses, ideation and behavior from pages 1 & 2 of the S-STS CMCM"\\r\\n                },\\r\\n                {\\r\\n                    "title": "2",\\r\\n                    "text": "Amount of time spent daily with suicidal ideation and behaviors"\\r\\n                },\\r\\n                {\\r\\n                    "title": "3",\\r\\n                    "text": "Feeling a need to make an attempt sooner rather than later"\\r\\n                },\\r\\n                {\\r\\n                    "title": "4",\\r\\n                    "text": "History of impulsive suicidality"\\r\\n                },\\r\\n                {\\r\\n                    "title": "5",\\r\\n                    "text": "Hearing voices telling or commanding you to kill yourself or someone else"\\r\\n                },\\r\\n                {\\r\\n                    "title": "6",\\r\\n                    "text": "Feeling trapped"\\r\\n                },\\r\\n                {\\r\\n                    "title": "7",\\r\\n                    "text": "Feeling overwhelmed"\\r\\n                },\\r\\n                {\\r\\n                    "title": "8",\\r\\n                    "text": "Exhaustion from struggling against suicide"\\r\\n                },\\r\\n                {\\r\\n                    "title": "9",\\r\\n                    "text": "Hopless feeling or nothing to live for"\\r\\n                },\\r\\n                {\\r\\n                    "title": "10",\\r\\n                    "text": "Easy access to guns or means for suicide"\\r\\n                },\\r\\n                {\\r\\n                    "title": "11",\\r\\n                    "text": "Seriousness of past suicide attempt(s)"\\r\\n                },\\r\\n                {\\r\\n                    "title": "12",\\r\\n                    "text": "Religious or spiritual reasons that influence your decision to kill yourself"\\r\\n                },\\r\\n                {\\r\\n                    "title": "13",\\r\\n                    "text": "Spending time on suicide or death related internet sites"\\r\\n                }\\r\\n            ]\\r\\n        },\\r\\n        {\\r\\n            "title": "Family / Social",\\r\\n            "questions": [\\r\\n                {\\r\\n                    "title": "14",\\r\\n                    "text": "Recent loss or death of a loved one"\\r\\n                },\\r\\n                {\\r\\n                    "title": "15",\\r\\n                    "text": "Recent anniversary of the death of a loved one"\\r\\n                },\\r\\n                {\\r\\n                    "title": "16",\\r\\n                    "text": "Recent conflict or break up with family, spouse, partner or close friends"\\r\\n                },\\r\\n                {\\r\\n                    "title": "17",\\r\\n                    "text": "Lonely or socially isolated or homeless"\\r\\n                },\\r\\n                {\\r\\n                    "title": "18",\\r\\n                    "text": "Lack of close family or social support"\\r\\n                },\\r\\n                {\\r\\n                    "title": "19",\\r\\n                    "text": "Withdrawal from family, work or social responsibilities"\\r\\n                },\\r\\n                {\\r\\n                    "title": "20",\\r\\n                    "text": "Bisexual, homosexual or transgender or uncertain sexual or gender orientation with resulting unsupportive family or support system"\\r\\n                },\\r\\n                {\\r\\n                    "title": "21",\\r\\n                    "text": "First or second degree relative with a history of suicidal impulses, ideation or behavior (including attempts or completed suicide)"\\r\\n                }\\r\\n            ]\\r\\n        },\\r\\n        {\\r\\n            "title": "Personal History",\\r\\n            "questions": [\\r\\n                {\\r\\n                    "title": "22",\\r\\n                    "text": "Had a recent major life change or loss (e.g. loss of job, school failure, financial loss, gambling loss, mounting financial debt)"\\r\\n                },\\r\\n                {\\r\\n                    "title": "23",\\r\\n                    "text": "Recent trouble with the law or serious legal problems or recent incarceration"\\r\\n                },\\r\\n                {\\r\\n                    "title": "24",\\r\\n                    "text": "Recent deep sense of shame or loss of reputation"\\r\\n                },\\r\\n                {\\r\\n                    "title": "25",\\r\\n                    "text": "Survivor of sexual abuse, sexual violence or rape"\\r\\n                },\\r\\n                {\\r\\n                    "title": "26",\\r\\n                    "text": "Survivor of violence, torture bullying or emotional abuse"\\r\\n                },\\r\\n                {\\r\\n                    "title": "27",\\r\\n                    "text": "Witnessed or caused serious violence or death to another person"\\r\\n                },\\r\\n                {\\r\\n                    "title": "28",\\r\\n                    "text": "Recent military service or service in a war zone or a war survivor"\\r\\n                },\\r\\n                {\\r\\n                    "title": "29",\\r\\n                    "text": "History of or current aggressive or violent behavior or high irritability"\\r\\n                },\\r\\n                {\\r\\n                    "title": "30",\\r\\n                    "text": "History of risk taking"\\r\\n                },\\r\\n                {\\r\\n                    "title": "31",\\r\\n                    "text": "Male over 55"\\r\\n                }\\r\\n            ]\\r\\n        },\\r\\n        {\\r\\n            "title": "Health",\\r\\n            "questions": [\\r\\n                {\\r\\n                    "title": "32",\\r\\n                    "text": "Depression or bipolar disorder"\\r\\n                },\\r\\n                {\\r\\n                    "title": "33",\\r\\n                    "text": "Panic attacks or high anxiety or agitation"\\r\\n                },\\r\\n                {\\r\\n                    "title": "34",\\r\\n                    "text": "Schizophrenia or schizoaffective disorder"\\r\\n                },\\r\\n                {\\r\\n                    "title": "35",\\r\\n                    "text": "Alcohol abuse"\\r\\n                },\\r\\n                {\\r\\n                    "title": "36",\\r\\n                    "text": "Substance (drug) abuse"\\r\\n                },\\r\\n                {\\r\\n                    "title": "37",\\r\\n                    "text": "Posttraumatic Stress Disorder"\\r\\n                },\\r\\n                {\\r\\n                    "title": "38",\\r\\n                    "text": "Recent sleep disturbance"\\r\\n                },\\r\\n                {\\r\\n                    "title": "39",\\r\\n                    "text": "Have an \\"incurable disease\\" or severe chronic or terminal illness"\\r\\n                },\\r\\n                {\\r\\n                    "title": "40",\\r\\n                    "text": "In Have an “incurable disease” or severe chronic or terminal illness"\\r\\n                },\\r\\n                {\\r\\n                    "title": "41",\\r\\n                    "text": "Recent unplanned pregnancy or sexually transmitted disease"\\r\\n                },\\r\\n                {\\r\\n                    "title": "42",\\r\\n                    "text": "Recent infection, inflammatory states (allergies or asthma) or an autoimmune disease flare up (e.g. Crohn\'s Disease, Lupus or Multiple Sclerosis)"\\r\\n                },\\r\\n                {\\r\\n                    "title": "43",\\r\\n                    "text": "Head injury"\\r\\n                },\\r\\n                {\\r\\n                    "title": "44",\\r\\n                    "text": "Unable to get needed psychiatric treatment or medication"\\r\\n                },\\r\\n                {\\r\\n                    "title": "45",\\r\\n                    "text": "Switched from a medication or a formulation or a dose that was effective or you were not taking your medication as directed"\\r\\n                },\\r\\n                {\\r\\n                    "title": "46",\\r\\n                    "text": "Recently started on a psychiatric or an antiepileptic medication"\\r\\n                },\\r\\n                {\\r\\n                    "title": "47",\\r\\n                    "text": "Other:",\\r\\n                    "isOther": "true"\\r\\n                },\\r\\n                {\\r\\n                    "title": "48",\\r\\n                    "text": "Other:",\\r\\n                    "isOther": "true"\\r\\n                }\\r\\n            ]\\r\\n        }\\r\\n    ]\\r\\n}',
                      questionHelpText: 'Add and score additional "other" factors as necessary.',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'grid',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 30,
                    itemType: 'question',
                    questionId: 20937,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: '15',
                      title: '15',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'If answer 14 is positive ask:<br> In the past (timeframe),',
                      questionText: 'how many times did you attempt suicide?',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'number',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 20952,
                answer: {
                  value:
                    '{"1":{"value":"1"},"2":{"value":"0"},"3":{"value":"1"},"4":{"value":"0"},"5":{"value":"1"},"6":{"value":"0"},"7":{"value":"1"},"8":{"value":"0"},"31":{"value":"1"},"47":{"value":"2","factor":"This is factor 1"},"48":{"value":"6","factor":"This is factor 2"},"50":{"value":"1","factor":"This is factor 5"},"52":{"value":"1","factor":"This is factor 6"}}',
                },
              },
              {
                questionId: 20937,
                answer: {
                  value: 2,
                },
              },
            ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    // Table question #1, #2
    if (interviewTestId === 15) {
      return res(
        ctx.json({
          interviewId: 30,
          interviewMode: 'C',
          interviewTestId: 3690,
          nViewPatientId: '506221267444',
          extPatientId: '',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 205,
                    itemType: 'question',
                    questionId: 20975,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: [''],
                      name: 'Patient Treatment Needs',
                      title: 'Patient Treatment Needs',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'At this time:',
                      questionText:
                        '{\\r\\n    "columns": ["Score", "Treatment level you think you currently need for suicidal impulses, thoughts or behaviors"],\\r\\n    "rows": [\\r\\n        ["10", "I need to be in the hospital for more than 24 hours, with someone watching or protecting me at all times and I need or I request physical or medication restraints to protect me from trying to kill myself.<br>(24/7 inpatient with constant one-on-one observation, possible need or request for physical or chemical restraints)"],\\r\\n        ["9", "I need to be in the hospital for more than 24 hours, with someone watching or protecting me at all times.<br>(24/7 inpatient one-on-one)"],\\r\\n        ["8", "I need to be in the hospital for more than 24 hours, with someone watching or checking on me every 15 minutes.<br>(24/7 inpatient on suicide precautions (e.g. 15 minute checks))"],\\r\\n        ["7", "I need to be in the hospital for more than 24 hours, but without any special need for someone to regularly check on me because of my suicidal impulses, thoughts or behaviors.<br>(24/7 inpatient, without special suicide precautions)"],\\r\\n        ["6", "I need to be in the hospital for more than 24 hours and be allowed to leave the ward or to go on visits outside the hospital from time to time.<br>(24/7 inpatient with privileges to leave ward on visits outside hospital)"],\\r\\n        ["5", "I need to stay up to 24 hours in the Emergency Room and then talk to the doctor again to decide if it is safe to discharge me home or if I need to be admitted to the hospital ward or if I need to attend therapy for several hours, multiple times a week.<br>(Stay up to 24 hours in Emergency Room then re-evaluate whether to admit or discharge or partial hospitalization or intensive outpatient program)"],\\r\\n        ["4", "I only need outpatient weekly visits with daily calls to tell my doctor or therapist if I am OK (what are called daily check-ins)."],\\r\\n        ["3", "I only need outpatient weekly visits."],\\r\\n        ["2", "I only need outpatient visits at least monthly."],\\r\\n        ["1", "I only need outpatient visits as needed and I would like to be monitored in case my suicidal impulses, thoughts or behaviors get worse."],\\r\\n        ["0", "I need no treatment at all."]\\r\\n    ]\\r\\n}',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'table',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 225,
                    itemType: 'question',
                    questionId: 20979,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Table 1',
                      title: 'Table 1',
                      subTitle: '',
                      language: 'en',
                      questionPrompt:
                        'Clinician judgment of patient’s risk of a suicide attempt or death by suicide <em>at this time</em>',
                      questionText:
                        '{\\r\\n    "columns": ["Score", "Judgment of Suicide Risk <em>At This Time</em>", "Judgment on Level of Management Needed for Suicidality"],\\r\\n    "rows": [\\r\\n        ["10", "Imminent", "24/7 inpatient with constant one-on-one observation and with possible need or patient request for physical or chemical restraints"],\\r\\n        ["9", "Severe", "24/7 inpatient one-on one hospitalization with constant one-on-one observation"],\\r\\n        ["8", "High", "24/7 inpatient hospitalization with suicide precautions (e.g. 15-minute observation checks)"],\\r\\n        ["7", "Major", "24/7 inpatient hospitalization without any special suicide precautions"],\\r\\n        ["6", "Elevated", "24/7 inpatient hospitalization with privileges to leave ward on visits outside hospital"],\\r\\n        ["5", "Moderate", "Up to 24 hours in ER, then re-evaluate whether to admit or discharge or partial hospitalization or intensive outpatient program"],\\r\\n        ["4", "Modest", "Outpatient weekly visits with daily check-ins"],\\r\\n        ["3", "Mild", "Outpatient weekly visits"],\\r\\n        ["2", "Slight", "Outpatient visits at least monthly"],\\r\\n        ["1", "Remote", "Outpatient visits as needed and if in treatment monitor for treatment emergent suicidality"],\\r\\n        ["0", "No apparent risk", "None"]\\r\\n    ]\\r\\n}',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'table',
                      defaultAnswer: '',
                      isClinicianOnly: true,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 20975,
                answer: {
                  value: 2,
                },
              },
              {
                questionId: 20979,
                answer: {
                  value: 8,
                },
              },
            ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    // StsEvent
    if (interviewTestId === 17) {
      return res(
        ctx.json({
          interviewId: 30,
          interviewMode: 'C',
          interviewTestId: 3690,
          nViewPatientId: '506221267444',
          extPatientId: '',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 32,
                    itemType: 'question',
                    questionId: 20939,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: '16',
                      title: '16',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'If answer 12 is positive ask:<br> In the past (timeframe),',
                      questionText:
                        'how many times did you take active steps to prepare for a suicide attempt in which you expected or intended to die (include anything done or purposely not done that put you closer to making a suicide attempt)?<br> (Include only the times when you stopped short of making an actual suicide attempt.)',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'number',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 33,
                    itemType: 'question',
                    questionId: 20940,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: '16 (events)',
                      title: '',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText: 'When? How? How serious was each preparation?',
                      questionHelpText:
                        '<b>Levels of Preparation</b><br> <b>Level 1</b>: You took active steps to prepare to kill yourself, but you did not start the suicide attempt.<br> <b>Level 2</b>: You were about to try to kill yourself, but then <b>you stopped yourself</b> just before harming yourself.<br> <b>Level 3</b>: You were about to try to kill yourself, but then <b>someone or something stopped you</b> just before harming yourself.',
                      clinicianHelpText: '',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'stsEvent',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            // previousAnswers: [
            //   {
            //     questionId: 20939,
            //     answer: {
            //       value: 2,
            //     },
            //   },
            //   {
            //     questionId: 20940,
            //     answer: {
            //       value:
            //         '[{"date":"01/01/2022","how":"This is how 1","scaleValue":1,"level":1},{"date":"03/03/2022","how":"This is how 2","scaleValue":1,"level":1}]',
            //     },
            //   },
            // ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    // Info no answer
    if (interviewTestId === 18) {
      return res(
        ctx.json({
          interviewId: 30,
          interviewMode: 'C',
          interviewTestId: 3690,
          nViewPatientId: '506221267444',
          extPatientId: '',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 45,
                    itemType: 'question',
                    questionId: 20953,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Patient Rated Pages Section',
                      title: 'Patient Rated Pages Section',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        '<h2>PATIENT RATED PAGES</h2>\\r\\n<br>\\r\\n<h2>Clinically Meaningful Change Measures for Suicide Outcomes Assessment</h2>\\r\\n<br>',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'infoNoAnswer',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 46,
                    itemType: 'question',
                    questionId: 20951,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Current Factors Text',
                      title: 'Current Factors Text',
                      subTitle: '',
                      language: 'en',
                      questionPrompt:
                        'Current Factors to Consider in Making the Clinically Meaningful Change Assessment',
                      questionText:
                        'Some consider the factors below as risk factors for suicidality. However, they are all not necessarily so and sometimes they can be protective factors. The impact of each factor can change over time within an individual.<br><br>The factors are intended to serve as useful prompts during the evaluation and in tracking both initial and newly emerging factors during follow up. If any of the factors disturb you, please discuss it with your clinician.<br><br>Indicate the impact of the factors below on your suicidality over the past week.',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'infoNoAnswer',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 210,
                    itemType: 'question',
                    questionId: 20976,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Clinician Rated Pages Section Text',
                      title: 'Clinician Rated Pages Section Text',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        '<h2>CLINICIAN RATED PAGES</h2>\\r\\n<h3>Clinically Meaningful Change Measures for Suicide Outcomes Assessment</h3>\\r\\nBased on all the information available above in the S-STS CMCM version, and using your clinical experience, rate your judgment of the patient’s global severity of suicidality at this time. Give a single score based on the metric below:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'infoNoAnswer',
                      defaultAnswer: '',
                      isClinicianOnly: true,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 220,
                    itemType: 'question',
                    questionId: 20978,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Clinically Meaningful Change Measures for Suicide Outcomes Assessment',
                      title:
                        'Clinically Meaningful Change Measures for Suicide Outcomes Assessment',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        '<h2>Clinically Meaningful Change Measures for Suicide Outcomes Assessment</h2>\\r\\n<h3>(CLINICIAN RATED)</h3>\\r\\n<p>This Sheehan - Suicidality Tracking Scale, Clinically Meaningful Change Measures version (S-STS CMCM version) is for use in evaluating whether a treatment for suicidality has a clinically meaningful impact beyond the suicidal phenomena alone.</p>\\r\\n<p>Suicide risk cannot be accurately predicted at an individual level. However, based on all the information available on pages 1 and 2, and on pages 4 through 10 in the S-STS CMCM version, and using your clinical experience, provide your best judgment of this patient’s level of clinically meaningful suicide risk and their need for treatment of suicidality at this time, using the anchors in table 1 below. In table 1 this clinician “judgment of suicide risk” at this time should align with your “judgment of level of management needed”. In addition, rate your judgment of the likelihood of this patient making a suicide attempt or of dying by suicide in the next 7 days on the discretized analog (DISCAN) metric on page 12 below. Ask any additional probe questions and request any clarifications as needed.</p>\\r\\n<p>\\r\\nIn making this judgment, factor in and make balanced trade-offs between the following elements in each case:\\r\\n<ul>\\r\\n<li>Suicidal ideation (including suicidal impulses, and dreams, hallucinations and delusions involving suicide)</li>\\r\\n<li>Suicidal planning</li>\\r\\n<li>Suicidal intent and patient’s perception of how likely they are to attempt suicide again in the future</li>\\r\\n<li>Suicidal behaviors (including impulsive suicidality)</li>\\r\\n<li>Suicide risk / protective factors</li>\\r\\n<li>Ability and willingness to cope with and to stay safe from suicidality</li>\\r\\n<li>Desire to recover from suicidality</li>\\r\\n<li>History of suicidality</li>\\r\\n<li>Quality of life</li>\\r\\n<li>% of suicidal ideation that is willful or deliberate</li>\\r\\n<li>Time spent in suicidality</li>\\r\\n<li>Global severity of suicidal impulses, ideation and behaviors</li>\\r\\n<li>Type of suicide disorder</li>\\r\\n</ul>\\r\\n</p>\\r\\n<p>These factors and trade-offs vary from one case to the next and over time in the same case.</p>',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'infoNoAnswer',
                      defaultAnswer: '',
                      isClinicianOnly: true,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    //sdsScale
    if (interviewTestId === 19) {
      return res(
        ctx.json({
          interviewId: 30,
          interviewMode: 'C',
          interviewTestId: 3690,
          nViewPatientId: '506221267444',
          extPatientId: '',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 150,
                    itemType: 'question',
                    questionId: 20964,
                    question: {
                      possibleAnswers: [
                        'N/A',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                      ],
                      displayAnswers: [''],
                      name: 'Work* / School',
                      title: 'Work* / School',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'In the past week:',
                      questionText: 'The suicide symptoms have disrupted your work / school work:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'sdsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: true,
                      questionSkipCheckboxText:
                        'I have not worked /studied at all during the past (timeframe) for <b>reasons unrelated to the suicide symptoms.</b><br>* Work includes paid, unpaid volunteer work or training. If your symptoms interfered with your ability to find or hold a job or contributed in any way to your currently not working, you must give a score on this scale.',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 100,
                    itemType: 'question',
                    questionId: 20955,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                      displayAnswers: [''],
                      name: 'Hopelessness',
                      title: 'Hopelessness',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'In the past week,',
                      questionText: 'Rate your level of hopelessness:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'sdsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 118,
                name: 'S-STS CMCM Main Module',
                letter: 'S-STS CMCM',
                title: 'S-STS (CMCM Version)',
                language: 'en',
              },
            ],
            modulesForScoring: [118],
            name: 'S-STS CMCM',
            title: 'SHEEHAN-SUICIDALITY TRACKING SCALE',
            subTitle: '(S-STS CMCM Version)',
            language: 'en',
            versionNumber: '10/6/16',
            backNavigationClinician: false,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    //SDS interview
    if (interviewTestId === 20) {
      return res(
        ctx.json({
          interviewId: 6,
          interviewMode: 'C',
          interviewTestId: 87746,
          nViewPatientId: '046889657051',
          extPatientId: 'ALL',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 1590,
                    question: {
                      possibleAnswers: [
                        'N/A',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                      ],
                      possibleAnswersText: [
                        'Not at all',
                        'Mildly',
                        'Moderately',
                        'Markedly',
                        'Extremely',
                      ],
                      displayAnswers: [''],
                      name: 'Work*/School',
                      title: 'Work*/School',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'Since you last completed this form',
                      questionText: 'The symptoms have disrupted your work / school work:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'sdsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: true,
                      questionSkipCheckboxText:
                        'I have not worked /studied at all during the past week <b>for reasons unrelated to the disorder.</b><br>* Work includes paid, unpaid volunteer work or training. If your symptoms interfered with your ability to find or hold a job or contributed in any way to your currently not working, you must give a score on this scale.',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 1591,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                      possibleAnswersText: [
                        'Not at all',
                        'Mildly',
                        'Moderately',
                        'Markedly',
                        'Extremely',
                      ],
                      displayAnswers: [''],
                      name: 'Social Life',
                      title: 'Social Life',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'Since you last completed this form',
                      questionText:
                        'The symptoms have disrupted your social life / leisure activities:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'sdsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 1592,
                    question: {
                      possibleAnswers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                      possibleAnswersText: [
                        'Not at all',
                        'Mildly',
                        'Moderately',
                        'Markedly',
                        'Extremely',
                      ],
                      displayAnswers: [''],
                      name: 'Family Life / Home Responsibilities',
                      title: 'Family Life / Home Responsibilities',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: 'Since you last completed this form',
                      questionText:
                        'The symptoms have disrupted your family life / home responsibilities:',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'sdsScale',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: true,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 4,
                    itemType: 'question',
                    questionId: 1593,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Days Lost',
                      title: 'Days Lost',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        'On how many days in the last week did your symptoms cause you to miss school or work or leave you unable to carry out your normal daily responsibilities? <u><b></b></u>',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'number',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: true,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 5,
                    itemType: 'question',
                    questionId: 1594,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: [''],
                      name: 'Days Underproductive',
                      title: 'Days Underproductive',
                      subTitle: '',
                      language: 'en',
                      questionPrompt: '',
                      questionText:
                        'On how many days in the last week did you feel so impaired by your symptoms, that even though you went to school or work or had other daily responsibilities, your productivity was reduced? <u><b></b></u>',
                      questionHelpText: '',
                      clinicianHelpText: '',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'number',
                      defaultAnswer: '',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: true,
                      questionCanBeSkippedWithOption: false,
                      questionSkipCheckboxText: '',
                      isRequired: true,
                      fillPlaceholder: '',
                      shouldFillWithTimeframe: false,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 64,
                name: 'SDS',
                letter: 'SDS',
                title: 'SDS',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 1590,
                answer: {
                  value: 5,
                },
              },
              {
                questionId: 1591,
                answer: {
                  value: 4,
                },
              },
              {
                questionId: 1592,
                answer: {
                  value: 2,
                },
              },
              {
                questionId: 1593,
                answer: {
                  value: 5,
                },
              },
              {
                questionId: 1594,
                answer: {
                  value: 4,
                },
              },
            ],
            modulesForScoring: [64],
            name: 'SDS',
            title: 'SHEEHAN DISABILITY SCALE',
            subTitle: 'A BRIEF, PATIENT RATED, MEASURE OF DISABILITY AND IMPAIRMENT',
            language: 'en',
            versionNumber: '1',
            backNavigationClinician: false,
            backNavigationPatient: false,
            hasPrimaryDiagnosis: false,
            hasTimeframe: true,
            reportType: 'sdsSts',
          },
        })
      );
    }

    //MINI 702 - screener interview
    if (interviewTestId === 21) {
      return res(
        ctx.json({
          interviewId: 5,
          interviewMode: 'C',
          interviewTestId: 87762,
          nViewPatientId: '046889657051',
          extPatientId: 'ALL',
          language: 'en',
          interviewStatus: 'inProgress',
          canNavigateBack: false,
          interview: {
            modules: [
              {
                sequenceOrders: [
                  {
                    sequenceOrder: 0,
                    itemType: 'question',
                    questionId: 1488,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenA1',
                      title: 'A',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you felt sad or depressed, down or empty, or grouchy or annoyed, <b> most of the day, nearly every day</b> for the past two weeks?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 1,
                    itemType: 'question',
                    questionId: 1489,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenA2',
                      title: 'A',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past 2 weeks</b>, have you been bored a lot or much less interested in things (like playing your favorite games) for <b>most of the day, nearly every day</b>? Have felt that you couldn’t enjoy things?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 2,
                    itemType: 'question',
                    questionId: 1490,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenB',
                      title: 'B',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you <b>ever</b> felt so bad that you wished you were dead, or planned to kill yourself, or tried to hurt yourself, or tried to kill yourself?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 3,
                    itemType: 'question',
                    questionId: 1491,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenC1',
                      title: 'C',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        "Has there <b>ever</b> been a time when you were so happy that you felt really 'up' or 'high' or 'hyper' and full of energy? By 'up' or 'high' I mean feeling really good; full of energy; needing less sleep; your thoughts going very fast or being full of ideas.",
                      questionHelpText: null,
                      clinicianHelpText:
                        'Do not consider times when you were intoxicated on drugs or alcohol or during situations that normally over stimulate and make children very excited like Christmas, birthdays, etc.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 4,
                    itemType: 'question',
                    questionId: 1492,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenC2',
                      title: 'C',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        "Are you <b>currently</b> feeling full of energy or 'up' or 'high' or 'hyper' and more active than usual?",
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 5,
                    itemType: 'question',
                    questionId: 1493,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenC3',
                      title: 'C',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Has there <b>ever</b> been a time when you were so grouchy or annoyed for several days, that you yelled or started fights with people outside your family? Have you or others noticed that you have been more grouchy than other kids, even when you thought you were right to act this way?',
                      questionHelpText: null,
                      clinicianHelpText:
                        'If <b>yes</b> to <b>any</b>, code <b>yes</b>. <br> Do not consider times when you were intoxicated on drugs or alcohol or during situations that normally overstimulate and make children very grouchy or annoyed.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 6,
                    itemType: 'question',
                    questionId: 1494,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenC4',
                      title: 'C',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Are you <b>currently</b> feeling grouchy or annoyed most of the time?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 7,
                    itemType: 'question',
                    questionId: 1495,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenD',
                      title: 'D',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you <b>ever</b> been really frightened or nervous for no reason; or have you <b>ever</b> been really frightened or nervous in a situation where most kids would not feel that way?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 8,
                    itemType: 'question',
                    questionId: 1496,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenE',
                      title: 'E',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Do you feel anxious, scared, or uneasy in places or situations where you might become really frightened: like being in a crowd or in a closed place, standing in a line (queue), when you are all alone, or when crossing a bridge or when you are in an open space, traveling in a bus, train, car or on a subway?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 9,
                    itemType: 'question',
                    questionId: 1497,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenF',
                      title: 'F',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'In the past month, were you really afraid about being away from someone close to you; or have you been really afraid that you would lose somebody you are close to? (Like getting lost from your parents or having something bad happen to them.)',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>either</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 10,
                    itemType: 'question',
                    questionId: 1498,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenG',
                      title: 'G',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past month</b>, were you afraid or embarrassed when others were watching you? Were you afraid of being teased? Like talking in front of the class? Or eating or writing or doing things in front of others?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 11,
                    itemType: 'question',
                    questionId: 1499,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenH',
                      title: 'H',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past month</b>, have you been really afraid of something like: snakes or bugs? Dogs or other animals? High places? Flying? Storms? The dark? Or seeing blood or needles?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 12,
                    itemType: 'question',
                    questionId: 1500,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: null,
                      name: 'ScreenH_specific_phobia',
                      title: 'H',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'List the specific phobia:',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'text',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 13,
                    itemType: 'question',
                    questionId: 1501,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenI1',
                      title: 'I',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past month</b>, have you been bothered by bad things that come into your mind that you couldn’t get rid of? Like bad thoughts or urges? Or nasty pictures? For example, did you think about hurting somebody even though you knew you didn’t want to? Were you afraid you or someone would get hurt because of some little thing you did or didn’t do? Did you worry a lot about having dirt or germs on you? Did you worry a lot that you would give someone else germs or make them sick somehow? Or were you afraid that you would do something really shocking?',
                      questionHelpText: null,
                      clinicianHelpText:
                        'Clinician: do not include simply excessive worries about real life problems. Do not include obsessions directly related to hoarding, hair pulling, skin picking, body dysmorphic disorder, to eating disorders, sexual behavior, pathological gambling, or alcohol or drug abuse because you may derive pleasure from the activity and may want to resist it only because of its negative consequences.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 14,
                    itemType: 'question',
                    questionId: 1502,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenI2',
                      title: 'I',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'In the past month, did you do something over and over without being able to stop doing it, like washing over and over? Straightening things up over and over? Counting something or checking on something over and over? Saying or doing something over and over?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 15,
                    itemType: 'question',
                    questionId: 1503,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenJ1',
                      title: 'J',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Has anything really awful happened to you? Like being in a flood, tornado or earthquake? Like being in a fire or a really bad accident? Like seeing someone being killed or badly hurt? Have you ever been attacked by someone?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 16,
                    itemType: 'question',
                    questionId: 1504,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenJ2',
                      title: 'J',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past month</b>, has this awful thing come back to you in some way? Like dreaming about it or having a strong memory of it or feeling it in your body?',
                      questionHelpText: null,
                      clinicianHelpText: 'If <b>yes</b> to <b>any</b>, code <b>yes</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 17,
                    itemType: 'question',
                    questionId: 1505,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenK',
                      title: 'K',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'In the past <b>year</b>, have you had 3 or more drinks of alcohol in a day? At those times, did you have 3 or more drinks in 3 hours? Did you do this 3 or more times in the past year?',
                      questionHelpText: null,
                      clinicianHelpText: '<b>If NO</b> to <b>any</b>, code <b>NO</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: 'no',
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 18,
                    itemType: 'question',
                    questionId: 1512,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenL',
                      title: 'L',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: '<b>Read the list below</b> of street drugs or medicines.',
                      questionText:
                        '<ul> <li>amphetamines</li> <li>speed</li> <li>crystal meth</li> <li>Dexedrine®</li> <li>Ritalin®, diet pills</li> <li>cocaine</li> <li>crack</li> <li>freebase</li> <li>speedball</li> <li>snorting cocaine</li> <li>heroin</li> <li>morphine, methadone</li> <li>opium</li> <li>Demerol®</li> <li>codeine, Percodan®, OxyContin®</li> <li>LSD</li> <li>mescaline</li> <li>PCP, angel dust</li> <li>MDA,MDMA</li> <li>ecstacy, ketamine</li> <li>inhalants</li> <li>glue</li> <li>ether</li> <li>GHB</li> <li>steroids</li> <li>THC, marijuana</li> <li>cannabis, hashish</li> <li>grass</li> <li>weed, reefer</li> <li>barbiturates, Valium®, Xanax®, Ativan</li> </ul> <br> <b>In the past year</b>, have you taken any of them more than one time to get high? To feel better or to change your mood?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 19,
                    itemType: 'question',
                    questionId: 1513,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenM1',
                      title: 'M',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past month</b>, did you have movements of your body called ‘tics’? Tics are sudden, quick movements of some part of your body that are hard to control. A tic might be blinking your eyes over and over, twitches of your face, jerking your head, making a movement with your hand over and over, or squatting, or shrugging your shoulders over and over.',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 20,
                    itemType: 'question',
                    questionId: 1514,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenM2',
                      title: 'M',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you <b>ever</b> had a tic that made you say something or make a sound over and over and was hard to stop? Like coughing or sniffing or clearing your throat over and over when you did not have a cold; or grunting or snorting or barking; having to say certain words over and over, having to say bad words, or having to repeat sounds you hear or words that other people say?',
                      questionHelpText: null,
                      clinicianHelpText: '<b>If YES</b> to <b>any</b>, code <b>YES</b>.',
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 21,
                    itemType: 'question',
                    questionId: 1515,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN_O_P',
                      title: 'N,O,P',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Has anyone (teacher, baby sitter, friend or parent) ever complained about your behavior or performance in school?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 22,
                    itemType: 'question',
                    questionId: 1516,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN1',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: '<b>In the past 6 months:</b>',
                      questionText:
                        'Have you often not paid enough attention to details? Made careless mistakes in school?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 23,
                    itemType: 'question',
                    questionId: 1517,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN2',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you often had trouble keeping your attention focused when playing or doing schoolwork?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 24,
                    itemType: 'question',
                    questionId: 1518,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN3',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you often been told that you do not listen when others talk directly to you?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 25,
                    itemType: 'question',
                    questionId: 1519,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN4',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you often tried to avoid things that make you concentrate or think hard (like schoolwork)? Do you hate or dislike things that make you concentrate or think hard?',
                      questionHelpText: null,
                      clinicianHelpText: '<b>If YES</b> to <b>either</b>, code <b>YES</b>.',
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 26,
                    itemType: 'question',
                    questionId: 1520,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN5',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you often lost or forgotten things you needed? Like homework assignments, pencils, or toys?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 27,
                    itemType: 'question',
                    questionId: 1521,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenN6',
                      title: 'N',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Do you often get distracted easily by little things (like sounds or things outside the room)?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 28,
                    itemType: 'question',
                    questionId: 1522,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO1',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: '<b>In the past year:</b>',
                      questionText: 'Have you been in trouble repeatedly?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 29,
                    itemType: 'question',
                    questionId: 1523,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO2',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you bullied or threatened other people?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 30,
                    itemType: 'question',
                    questionId: 1524,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO3',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you hurt or threatened someone (physically) on purpose?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 31,
                    itemType: 'question',
                    questionId: 1525,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO4',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you hurt animals on purpose?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 32,
                    itemType: 'question',
                    questionId: 1526,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO5',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you stolen things?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 33,
                    itemType: 'question',
                    questionId: 1527,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO6',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you started fires on purpose?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 34,
                    itemType: 'question',
                    questionId: 1528,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO7',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you lied many times in order to get things from people?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 35,
                    itemType: 'question',
                    questionId: 1529,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenO8',
                      title: 'O',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you skipped school often?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 36,
                    itemType: 'question',
                    questionId: 1530,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenP1',
                      title: 'P',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: '<b>In the past 6 months:</b>',
                      questionText:
                        'Have you often argued with adults and refused to do what they asked you to do?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 37,
                    itemType: 'question',
                    questionId: 1531,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenP2',
                      title: 'P',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'Have you often annoyed people on purpose?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 38,
                    itemType: 'question',
                    questionId: 1532,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenQ1',
                      title: 'Q',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you ever heard things other people couldn’t hear, such as voices?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 39,
                    itemType: 'question',
                    questionId: 1533,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenQ2',
                      title: 'Q',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        "Have you ever had visions or have you ever seen things other people couldn't see?",
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 40,
                    itemType: 'question',
                    questionId: 1534,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenQ3',
                      title: 'Q',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have your friends or family ever thought any of your beliefs were strange or weird?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 41,
                    itemType: 'question',
                    questionId: 1535,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: null,
                      name: 'ScreenR_height',
                      title: 'R',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'How tall are you?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'height',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 42,
                    itemType: 'question',
                    questionId: 1536,
                    question: {
                      possibleAnswers: [''],
                      displayAnswers: null,
                      name: 'ScreenR_weight',
                      title: 'R',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText: 'What was your lowest weight in the past 3 months?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'weight',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 43,
                    itemType: 'question',
                    questionId: 1537,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenS_T1',
                      title: 'S,T',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past 3 months</b>, did you have eating binges or times when you ate a very large amount of food within a <b>2-hour</b> period?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 44,
                    itemType: 'question',
                    questionId: 1538,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenS_T2',
                      title: 'S,T',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        '<b>In the past 3 months</b>, during these binges, did you feel that you could not control your eating ?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: null,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 45,
                    itemType: 'question',
                    questionId: 1539,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenU',
                      title: 'U',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Have you worried <b>a lot</b> or been nervous about several things over the past 6 months?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                  {
                    sequenceOrder: 46,
                    itemType: 'question',
                    questionId: 1540,
                    question: {
                      possibleAnswers: ['yes', 'no'],
                      displayAnswers: null,
                      name: 'ScreenV',
                      title: 'V',
                      subTitle: null,
                      language: 'en',
                      questionPrompt: null,
                      questionText:
                        'Are you stressed out about something? Is this making you upset or making your behavior worse?',
                      questionHelpText: null,
                      clinicianHelpText: null,
                      questionScore: 0,
                      displayReportScore: false,
                      questionAnswerType: 'binary',
                      defaultAnswer: null,
                      isClinicianOnly: false,
                      isPatientOnly: false,
                      shouldFillPromptWAnswerValue: false,
                      shouldFillQuestionWAnswerValue: false,
                      questionCanBeSkippedWithOption: null,
                      questionSkipCheckboxText: null,
                      isRequired: true,
                      fillPlaceholder: null,
                      shouldFillWithTimeframe: null,
                      clientDisplayCondition: null,
                      relatedQuestionIdForAnswerValues: null,
                    },
                  },
                ],
                id: 61,
                name: 'MINI KID Screen 7.0.2 Main Module',
                letter: '1',
                title: '',
                language: 'en',
              },
            ],
            previousAnswers: [
              {
                questionId: 1488,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1489,
                answer: {
                  value: 'no',
                },
              },
              {
                questionId: 1490,
                answer: {
                  value: 'no',
                },
              },
              {
                questionId: 1491,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1492,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1493,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1494,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1495,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1496,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1497,
                answer: {
                  value: 'yes',
                },
              },
              {
                questionId: 1498,
                answer: {
                  value: 'yes',
                },
              },
              {
                // Binary
                questionId: 1499,
                answer: {
                  value: 'no',
                },
              },
              {
                // Text question
                questionId: 1500,
                answer: {
                  value: 'This is test answer',
                },
              },
              {
                // Height
                questionId: 1535,
                answer: {
                  valueCentimeters: 170,
                },
              },
              {
                // Weight
                questionId: 1536,
                answer: {
                  valueKilograms: 70,
                },
              },
            ],
            modulesForScoring: [61],
            name: 'M.I.N.I. KID 7.0.2 Screen',
            title: 'M.I.N.I. KID Screen 7.0.2',
            subTitle: null,
            language: 'en',
            versionNumber: '7.0.2',
            backNavigationClinician: null,
            backNavigationPatient: null,
            hasPrimaryDiagnosis: false,
            hasTimeframe: null,
            reportType: 'miniScreener',
          },
        })
      );
    }

    return res(ctx.status(404, 'Not found'));
  }),

  rest.post<any>('/v1/interview/submit-interview-answers', (req, res, ctx) => {
    const { interviewTestId, answers, action } = req.body;
    // Screener
    if (interviewTestId === 2) {
      // TODO: return something here
      return res(ctx.json({}));
    }

    // MINI
    if (interviewTestId === 1) {
      if (action === 'navigateBack') {
        return res(ctx.json(questionMocks[questionMockIds.binary]));
      }
      if (answers?.length) {
        const { questionId } = answers[0];

        const nextQuestion = questionMocks[questionId + 1] || {};
        return res(ctx.json(nextQuestion));
      }
    }
    return res(ctx.json({}));
  }),

  rest.post<any>('/v1/interview/check-expire-token', (req, res, ctx) => {
    return res(
      ctx.json({
        interviewTestId: 94040,
        interviewStatus: 'notStarted',
        reportType: 'sdsSts',
        patientInterviewToken:
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbnRlcnZpZXdUZXN0SWQiOjk0MDQwLCJsYXN0QWN0aXZpdHlUcyI6MTY1NTg4MzM3MDI5OSwiaWF0IjoxNjU1ODgzMzcwLCJleHAiOjE2NTU4ODQyNzB9.IIO7kBhWkIswjM2JALCbCYRI_LkGzl02aEzeaZ-8KLk',
        isShowMfa: true,
        mfaVerified: false,
        lockoutExpiration: '06/30/2022',
      })
    );
  }),
];

export default process.env.REACT_APP_INTERVIEW_MOCK_DISABLED === 'true' ? [] : mocks;
